import React from 'react'

import clsx from 'clsx'

import classes from './BlockHeading.module.scss'

const BlockHeading = props => {
  return <p className={clsx('BlockHeading', classes.root)} {...props} />
}

export default BlockHeading
